import { closeModal, openModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import EntityManager from "../../EntityManager";
import { changeLevel, gameData } from "../../GameManager";
import { fillWithLetters } from "../../words/letters";
import { PlayerPosition } from "./PlayerPosition";

export const CheatModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C) => {
  floodFill(C.display, C.bounds, Colors.BLACK);
  return [
    createElement(
      TextType,
      { x: 0, y: 0, w: 24, h: 1 },
      { title: "Cheat Menu Options" }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 1, w: 40, h: 1 },
      {
        title: "Remove all monsters",
        onClick: () => {
          gameData.actors.asArray().forEach((a) => {
            if (a !== gameData.player) {
              EntityManager.removeActorAndPieces(a);
            }
          });
          closeModal();
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 2, w: 40, h: 1 },
      {
        title: "Enable free type",
        onClick: () => {
          gameData.freeEntry = true;
          closeModal();
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 3, w: 40, h: 1 },
      {
        title: "Refill tiles",
        onClick: () => {
          gameData.player.spellWand = [];
          fillWithLetters(gameData.player, gameData.player.maxLetters);
          closeModal();
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 3, w: 40, h: 1 },
      {
        title: "Grant XP",
        onClick: () => {
          gameData.xp += 1;
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 4, w: 40, h: 1 },
      {
        title: "Advance Level",
        onClick: () => {
          closeModal();
          changeLevel();
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 5, w: 40, h: 1 },
      {
        title: "Lose Health",
        onClick: () => {
          closeModal();
          gameData.player.health.change(-1);
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 6, w: 40, h: 1 },
      {
        title: "Lose Hunger",
        onClick: () => {
          closeModal();
          gameData.player.hunger.change(-1);
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 0, y: 7, w: 40, h: 1 },
      {
        title: "Print Pieces",
        onClick: () => {
          closeModal();
          console.log(gameData.pieces.asArray());
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 2, y: 16, w: 6, h: 1 },
      { title: "Close", onClick: () => closeModal() }
    ),
  ];
};
